import moment from "moment";
import { getCurrentLanguage } from "./LanguageHelper";

export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";
export const FR_FRONTEND_DATE_FORMAT = "DD/MM/YYYY";
export const EN_FRONTEND_DATE_FORMAT = "MM/DD/YYYY";

export const BACKEND_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
export const FR_FRONTEND_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const EN_FRONTEND_DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm:ss";

export function getDateMoment(date: string) {
  return moment(date, BACKEND_DATE_FORMAT);
}
export function getDateTimeMoment(date: string) {
  return moment(date, BACKEND_DATE_TIME_FORMAT);
}

export function getDateFormat() {
  return getCurrentLanguage() === "fr"
    ? FR_FRONTEND_DATE_FORMAT
    : EN_FRONTEND_DATE_FORMAT;
}
export function getDateTimeFormat() {
  return getCurrentLanguage() === "fr"
    ? FR_FRONTEND_DATE_TIME_FORMAT
    : EN_FRONTEND_DATE_TIME_FORMAT;
}

export function formatDate(dateString: string) {
  return moment(dateString, BACKEND_DATE_FORMAT).format(getDateFormat());
}
export function formatDateTime(dateTimeString: string) {
  return moment(dateTimeString, BACKEND_DATE_TIME_FORMAT).format(
    getDateTimeFormat()
  );
}

export function formatPrice(value: string | number) {
  const formatter = new Intl.NumberFormat(getCurrentLanguage(), {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const price = typeof value === "string" ? parseFloat(value) : value;
  return `€ ${formatter.format(price)}`;
}

export function formatPercent(value: string | number) {
  return value + "%";
}
